import React, { useState } from 'react';
import { Power, PowerOff, AlertTriangle, CheckCircle2 } from 'lucide-react';
import Modal from './Modal';
import { fmtFechaHora } from './formato';

const MOTIVOS = ['Falta de pago', 'Contrato terminado', 'Solicitud del cliente', 'Uso indebido'];

// Suspender corta el servicio de la empresa en Punto V al instante (panel y
// máquinas); reactivar lo devuelve. Pide motivo para suspender.
const DialogoSuspension = ({ cliente, onConfirmar, onCancel }) => {
  const suspender = !cliente.suspendida;
  const [motivo, setMotivo] = useState('');
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);

  const confirmar = async (e) => {
    e.preventDefault();
    setError('');
    setGuardando(true);
    try {
      await onConfirmar(suspender ? motivo.trim() : null);
    } catch (err) {
      setError(err.message || 'No se pudo completar la operación');
      setGuardando(false);
    }
  };

  return (
    <Modal
      titulo={suspender ? `Suspender ${cliente.slug}` : `Reactivar ${cliente.slug}`}
      subtitulo={`${cliente.duenio.nombre} · ${cliente.base_datos}`}
      icono={suspender ? PowerOff : Power}
      tono={suspender ? 'rojo' : 'verde'}
      onClose={onCancel}
      bloqueado={guardando}
      ancho="md"
      pie={(
        <>
          <button type="button" onClick={onCancel} disabled={guardando} className="px-4 py-2 text-sm text-gray-700 rounded-lg hover:bg-gray-100">
            Cancelar
          </button>
          <button
            type="submit"
            form="form-suspension"
            disabled={guardando || (suspender && motivo.trim().length < 5)}
            className={`px-4 py-2 text-white rounded-lg text-sm font-medium disabled:opacity-50 flex items-center gap-2 ${
              suspender ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'
            }`}
          >
            {suspender ? <PowerOff size={15} /> : <Power size={15} />}
            {guardando ? (suspender ? 'Suspendiendo…' : 'Reactivando…') : (suspender ? 'Suspender cliente' : 'Reactivar cliente')}
          </button>
        </>
      )}
    >
      <form id="form-suspension" onSubmit={confirmar} className="space-y-4">
        {suspender ? (
          <div className="rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-800 space-y-1.5">
            <p className="font-semibold flex items-center gap-1.5"><AlertTriangle size={15} /> Corta el servicio al instante:</p>
            <ul className="list-disc pl-5 space-y-0.5">
              <li>Sus usuarios no pueden entrar a Punto V Manager y las sesiones abiertas se cierran.</li>
              <li>Sus máquinas dejan de autorizar ventas y recargas.</li>
              <li>Sus datos no se borran: al reactivarlo todo vuelve a funcionar.</li>
            </ul>
          </div>
        ) : (
          <div className="rounded-xl border border-green-200 bg-green-50 p-3 text-sm text-green-800 space-y-1">
            <p className="flex items-center gap-1.5"><CheckCircle2 size={15} /> Sus usuarios y máquinas vuelven a funcionar de inmediato.</p>
            {cliente.suspension && (
              <p className="text-green-700">
                Suspendido el {fmtFechaHora(cliente.suspension.desde)}{cliente.suspension.motivo ? `: ${cliente.suspension.motivo}` : ''}.
              </p>
            )}
          </div>
        )}

        {suspender && (
          <div>
            <label htmlFor="motivo-suspension" className="block text-sm font-medium text-gray-700 mb-2">Motivo *</label>
            <div className="flex flex-wrap gap-1.5 mb-2">
              {MOTIVOS.map(m => (
                <button
                  key={m}
                  type="button"
                  onClick={() => setMotivo(m)}
                  className={`px-2.5 py-1 rounded-full text-xs border ${
                    motivo === m ? 'bg-red-50 border-red-300 text-red-700' : 'border-gray-200 text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  {m}
                </button>
              ))}
            </div>
            <textarea
              id="motivo-suspension"
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              rows={2}
              maxLength={255}
              autoFocus
              placeholder="Queda registrado en Punto V"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm resize-none focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>
        )}

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 text-sm">{error}</div>
        )}
      </form>
    </Modal>
  );
};

export default DialogoSuspension;
